import SituacaoAcordaoBusiness from '@/dominio/SituacaoAcordaoBusiness';
import { makeObservable } from 'mobx';
import { Filtro } from './Filtro';

export default class FiltroSituacaoPublicacaoAcordao extends Filtro {
    tipo = 'booleano';
    exibicao = 'checkbox';

    get label() {
        return 'Acórdão deve ser publicado nesta sessão?';
    }

    constructor(props) {
        super(props);
        makeObservable(this);
    }

    getValorOpcao(registro) {
        return SituacaoAcordaoBusiness.isPublicacaoAcordaoObrigatoria(registro);
    }

    getDescricao(valor) {
        return this.labelBooleanoSimNao(valor);
    }
}
